import { createContext, SetStateAction, Dispatch } from "react";
import { FeatureInfoType } from "../types/FeatureInfoType";

export type FeatureInfoContext = {
    /**
    * Values of the current feature (plot)
    */
    featureInfo: FeatureInfoType;

    /**
     * Setter of the current feature info
     */
    setFeatureInfo?: Dispatch<SetStateAction<FeatureInfoType>>

    /**
    * Current `from - van` and `until - tot` years
    */
    years: [number | undefined, number | undefined];

    /**
     * Setter for years
     */
    setYears?: Dispatch<SetStateAction<[number | undefined, number | undefined]>>;

    /**
     * The highlight layer
     */
    highlightLayer: any;

    /**
    * The help layer
    */
    helpLayer: any;

    /**
     * The cadastral layers
     */
    cadastralLayers: any[];
};

export const FeatureInfoContext = createContext<FeatureInfoContext>({
    featureInfo: { nr: "", geom: "", from: 1832, until: 1832, toggle: 0, kt: "" },
    years: [1832, 1832],
    highlightLayer: {},
    helpLayer: {},
    cadastralLayers: [],
});